import { render, staticRenderFns } from "./BrowserOptions.vue?vue&type=template&id=5f23c666"
import script from "./BrowserOptions.vue?vue&type=script&lang=js"
export * from "./BrowserOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports